module.exports = "/_next/static/images/6349b6847d3e92cd4d95ec16e917ccab-paperwork@tablet768.jpg.webp";